import { render, staticRenderFns } from "./infotext.vue?vue&type=template&id=11bc0abe&"
import script from "./infotext.vue?vue&type=script&lang=js&"
export * from "./infotext.vue?vue&type=script&lang=js&"
import style0 from "./infotext.vue?vue&type=style&index=0&id=11bc0abe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports